import styles from "./AuthPages.module.css";
import { Form } from "src/components/ui-components/Form/Form";
import { AnchorButton } from "src/components/ui-components/Button/AnchorButton";
import { Button } from "src/components/ui-components/Button/Button";
import { useContext, useState } from "react";
import { useRouter } from "next/router";
import { CSRFContext } from "src/components/csrf/csrf";
import { AuthError } from "src/utils/api/auth";
import { httpPost } from "src/utils/http/http";
import { InputField } from "src/components/ui-components/Input/InputField";
import { useLoginUrl } from "src/hooks/useLoginUrl";
import { Logo } from "./Logo";

export function ResetPassword() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<AuthError>();
  const { csrf } = useContext(CSRFContext);
  const { push } = useRouter();
  const [username, setUsername] = useState("");

  const loginUrl = useLoginUrl();

  const onSubmit = (event: React.SyntheticEvent) => {
    event.preventDefault();

    if (username.includes("@")) {
      setError(new AuthError("InvalidUsernameException"));
    } else if (username) {
      const encoded = encodeURIComponent(username);
      const resetConfirmPath = `/auth/resetConfirm?username=${encoded}`;
      setLoading(true);
      reset(csrf!, username)
        .then(() => push(resetConfirmPath))
        .catch((err) => setError(new AuthError(err.message)))
        .then(() => {
          setLoading(false);
          setUsername("");
        });
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.logo}>
        <Logo />
      </div>
      <div className={styles.section}>
        <Form size="L" className={styles.form}>
          <h1 className={styles.title}>Reset your password</h1>

          <InputField
            size="L"
            style="contained"
            label="What's your username?"
            placeholder="Satoshi"
            onChange={(event) => {
              setUsername(event.target.value);
            }}
            value={username}
            required
          />

          {error && (
            <p role="alert" className={styles.error}>
              {error.label}
            </p>
          )}
          <Button
            size="L"
            theme="primary"
            className={styles.button}
            onClick={onSubmit}
            disabled={loading}
            loading={loading}
          >
            Send reset email
          </Button>
        </Form>

        <hr />

        <AnchorButton
          size="L"
          theme="primary-light"
          href={loginUrl}
          className={styles.button}
        >
          Sign in
        </AnchorButton>
      </div>
    </div>
  );
}

const reset = async (csrf: string, username: string) => {
  return httpPost<void>("/api/auth", {
    action: "reset",
    csrf,
    username,
  });
};
